<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Can't pay here</template>

    <Sheet.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        Please go to Dacr.com to pay your outstanding balance.
      </p>
    </Sheet.Body>

    <div
      class="flex shrink-0 flex-col gap-2.5 px-4 pt-2 pb-[calc(env(safe-area-inset-bottom)+16px)]"
    >
      <Button variant="primary" size="lg" @click="handleGoClick">
        Go to Dacr.com
      </Button>
      <Button variant="stroke" size="lg" @click="close()">Cancel</Button>
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import { useCantPay } from './useCantPay'

const { close } = useSheet()
const { handleGo } = useCantPay()

const handleGoClick = () => {
  handleGo()
  close()
}
</script>
